import {
  START_GET_HOME_LIST,
  SUCCESS_GET_HOME_LIST,
  ERROR_GET_HOME_LIST,
  START_GET_NO_OF_ALERT,
  SUCCESS_GET_NO_OF_ALERT,
  ERROR_GET_NO_OF_ALERT,
  SUCCESS_CHASEUP_CHART,
  ERROR_CHASEUP_CHART,
  START_CHASEUP_CHART,
  START_ORDER_CHART,
  SUCCESS_ORDER_CHART,
  ERROR_ORDER_CHART,
  SUCCESS_PAYMENT_CREATE,
  START_PAYMENT_CREATE,
  ERROR_PAYMENT_CREATE,
  START_PAYMENT_LINK,
  SUCCESS_PAYMENT_LINK,
  ERROR_PAYMENT_LINK,
  START_PAYMENT_LIST,
  SUCCESS_PAYMENT_LIST,
  ERROR_PAYMENT_LIST,
  START_SUBSCRIPTION_CREATE,
  SUCCESS_SUBSCRIPTION_CREATE,
  ERROR_SUBSCRIPTION_CREATE,
  CLEAR_SUBSCRIPTION_CREATE,
  START_SUBSCRIPTION_CANCEL,
  SUCCESS_SUBSCRIPTION_CANCEL,
  ERROR_SUBSCRIPTION_CANCEL,
  START_SUBSCRIPTION_UPDATE,
  SUCCESS_SUBSCRIPTION_UPDATE,
  ERROR_SUBSCRIPTION_UPDATE,
} from "Actions/HomeAction";
import {
  ERROR_ORDER_SPEED,
  START_ORDER_SPEED,
  SUCCESS_ORDER_SPEED,
} from "Actions/OrderPadAction";

const initialState = {
  homeList: {
    loading: false,
    data: [],
    error: [],
  },
  noOfAlertData: {
    loading: false,
    data: [],
    error: [],
  },
  orderSpeed: {
    loading: false,
    data: [],
    error: [],
  },
  chaseupChart: {
    loading: false,
    data: [],
    error: [],
  },
  orderChart: {
    loading: false,
    data: [],
    error: [],
  },
  paymentCreate: {
    loading: false,
    data: [],
    error: [],
  },
  paymentLinkAdd: {
    loading: false,
    data: [],
    error: [],
  },
  paymentListMain: {
    loading: false,
    data: [],
    error: [],
  },
};

export const HomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_GET_HOME_LIST: {
      return {
        ...state,
        homeList: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_GET_HOME_LIST: {
      return {
        ...state,
        homeList: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_GET_HOME_LIST: {
      return {
        ...state,
        homeList: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_GET_NO_OF_ALERT: {
      return {
        ...state,
        noOfAlertData: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_GET_NO_OF_ALERT: {
      return {
        ...state,
        noOfAlertData: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_GET_NO_OF_ALERT: {
      return {
        ...state,
        noOfAlertData: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_ORDER_SPEED: {
      return {
        ...state,
        orderSpeed: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_ORDER_SPEED: {
      return {
        ...state,
        orderSpeed: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_ORDER_SPEED: {
      return {
        ...state,
        orderSpeed: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_CHASEUP_CHART: {
      return {
        ...state,
        chaseupChart: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_CHASEUP_CHART: {
      return {
        ...state,
        chaseupChart: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_CHASEUP_CHART: {
      return {
        ...state,
        chaseupChart: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_ORDER_CHART: {
      return {
        ...state,
        orderChart: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_ORDER_CHART: {
      return {
        ...state,
        orderChart: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_ORDER_CHART: {
      return {
        ...state,
        orderChart: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_PAYMENT_CREATE: {
      return {
        ...state,
        paymentCreate: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_PAYMENT_CREATE: {
      return {
        ...state,
        paymentCreate: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_PAYMENT_CREATE: {
      return {
        ...state,
        paymentCreate: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_SUBSCRIPTION_CREATE: {
      return {
        ...state,
        subscriptionCreate: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_SUBSCRIPTION_CREATE: {
      return {
        ...state,
        subscriptionCreate: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_SUBSCRIPTION_CREATE: {
      return {
        ...state,
        subscriptionCreate: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_SUBSCRIPTION_UPDATE: {
      return {
        ...state,
        subscriptionUpdate: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_SUBSCRIPTION_UPDATE: {
      return {
        ...state,
        subscriptionUpdate: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_SUBSCRIPTION_UPDATE: {
      return {
        ...state,
        subscriptionUpdate: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_SUBSCRIPTION_CANCEL: {
      return {
        ...state,
        subscriptionCancel: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_SUBSCRIPTION_CANCEL: {
      return {
        ...state,
        subscriptionCancel: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_SUBSCRIPTION_CANCEL: {
      return {
        ...state,
        subscriptionCancel: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_PAYMENT_LINK: {
      return {
        ...state,
        paymentLinkAdd: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_PAYMENT_LINK: {
      return {
        ...state,
        paymentLinkAdd: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_PAYMENT_LINK: {
      return {
        ...state,
        paymentLinkAdd: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_PAYMENT_LIST: {
      return {
        ...state,
        paymentListMain: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_PAYMENT_LIST: {
      return {
        ...state,
        paymentListMain: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_PAYMENT_LIST: {
      return {
        ...state,
        paymentListMain: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_SUBSCRIPTION_CREATE: {
      return {
        ...state,
        subscriptionCreate: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_SUBSCRIPTION_CREATE: {
      return {
        ...state,
        subscriptionCreate: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_SUBSCRIPTION_CREATE: {
      return {
        ...state,
        subscriptionCreate: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case CLEAR_SUBSCRIPTION_CREATE: {
      return {
        ...state,
        subscriptionCreate: {
          loading: false,
          data: [],
          error: [],
        },
      };
    }
    case START_SUBSCRIPTION_UPDATE: {
      return {
        ...state,
        subscriptionUpdate: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_SUBSCRIPTION_UPDATE: {
      return {
        ...state,
        subscriptionUpdate: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_SUBSCRIPTION_UPDATE: {
      return {
        ...state,
        subscriptionUpdate: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_SUBSCRIPTION_CANCEL: {
      return {
        ...state,
        subscriptionCancel: {
          loading: true,
          data: [],
          error: [],
        },
      };
    }
    case SUCCESS_SUBSCRIPTION_CANCEL: {
      return {
        ...state,
        subscriptionCancel: {
          loading: false,
          data: action.payload,
          error: [],
        },
      };
    }
    case ERROR_SUBSCRIPTION_CANCEL: {
      return {
        ...state,
        subscriptionCancel: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    default: {
      return state || initialState;
    }
  }
};
